import { Component, OnInit } from '@angular/core';
import { OrganizationUpdateFormFactory } from './organization-update-form.factory';
import { AdvancedForm } from "@magieno/angular-advanced-forms";
import { OrganizationUpdateOptions } from '../../../../../../../../common/src/options/organization-update.options';
import { AdvancedFormControl } from "@magieno/angular-advanced-forms";
import { OrganizationManager } from '../../../managers/organization.manager';

@Component({
  selector: 'app-organization-settings',
  templateUrl: './organization-settings.component.html',
  styleUrls: ['./organization-settings.component.scss'],
  standalone: false,
})
export class OrganizationSettingsComponent implements OnInit {

  public readonly form: AdvancedForm<OrganizationUpdateOptions> = this.organizationUpdateFormFactory.create();

  constructor(public readonly organizationUpdateFormFactory: OrganizationUpdateFormFactory, public readonly organizationManager: OrganizationManager) {
  }

  get name(): AdvancedFormControl<string, string, string> {
    return this.form.get('name') as AdvancedFormControl<string, string, string>;
  }

  async ngOnInit(): Promise<void> {
    // Always refresh when entering the organization settings
    const organization = await this.organizationManager.refresh();

    if (organization !== null) {
      this.form.setValue(organization);
      this.form.formElements.name.disable();
    }

    // this.form.buttonClick$.subscribe((button: AdvancedFormButton) => {
    //   this.form.lifecycleStatus = FormLifecycleStatusEnum.Sending;
    // });
  }

}
